import { render, staticRenderFns } from "./CourseRejected.vue?vue&type=template&id=626edacc"
import script from "./CourseRejected.vue?vue&type=script&lang=js"
export * from "./CourseRejected.vue?vue&type=script&lang=js"
import style0 from "./CourseRejected.vue?vue&type=style&index=0&id=626edacc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports